import TempVehiclePictureModal from './maintain-vehicle-picture-modal.vue'
export default TempVehiclePictureModal
